var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"advertisement-header"},[_c('div',{staticClass:"advertisement-header-text"},[_c('h3',[_vm._v("企业咨询")]),_c('p',[_vm._v("致力于为各种规模和行业的企业提供高效、创新的咨询解决方案。")]),_c('div',{on:{"click":_vm.handleClick}},[_vm._v("发布信息")])])]),_c('common',{attrs:{"type":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }